import React from "react"
import separatorIcon from "../images/icon-slider_arrow.svg"
import { Link } from "gatsby"

function Breadcrumb({ location, postTitle }) {
  const fullPath = `${location.pathname}`
  let sections = fullPath.split("/").filter(Boolean)

  sections = sections.filter(section => section !== "restaurant")

  const titles = {
    merit: "フードデリバリーのメリット",
    advantage: "出前館の強み",
    cost: "出店費用",
    "start-guide": "出店の流れ",
    cases: "事例紹介",
    faq: "よくある質問",
    "get-started": "出店申込み",
    download: "資料ダウンロード",
    plan: "選べる配達プラン",
  }

  const links = sections.map((section, index) => {
    const url = "/" + sections.slice(0, index + 1).join("/")
    let title
    if (section === "plan") {
      title = titles[section]
    } else {
      title = index === 1 ? postTitle : titles[section] || section
    }
    return { title, url }
  })

  return (
    <div className="breadcrumb">
      <div className="container">
        <Link to="/">トップページ</Link>
        {links.map((link, index) => (
          <div className="breadcrumb__contents" key={`breadcrumb_${index}`}>
            <img src={separatorIcon} alt=">" className="separator" />
            {index === links.length - 1 ? (
              <p>{link.title}</p>
            ) : (
              <Link to={link.url}>{link.title}</Link>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Breadcrumb
